import React, { useState } from 'react';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from 'libraries/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import { deleteAssessmentFromJobVite } from 'requests/SubscriptionRequests';

const styles = () => ({
    actionButton: {
        fontWeight: 700,
        paddingRight: 20,
        paddingLeft: 20
    },
    deleteButton: {
        paddingRight: 40,
        paddingLeft: 40,
        fontWeight: 700,
        minWidth: 213
    },
    loader: {
        color: '#fff'
    }
});

const DeleteAssessmentFromJobViteDialog = ({ slug, setJobViteAssessmentShow, onClose, classes, open, flashMessage }) => {
    const [loading, setLoading] = useState(false);

    const deleteFromJobVite = (e) => {
        if (e) e.stopPropagation();
        setLoading(true);
        deleteAssessmentFromJobVite(slug)
            .then(() => {
                flashMessage('Assessment deleted from Jobvite', 'done');
                if (setJobViteAssessmentShow) setJobViteAssessmentShow(true);
            })
            .catch((err) => {
                if (err.response && err.response.status === 418) {
                    flashMessage('Not authorized in Jobvite', 'error');
                } else {
                    flashMessage('Something went wrong', 'error');
                }
            })
            .finally(() => {
                setLoading(false);
                onClose();
            });
    };

    return (
        <Dialog
            maxWidth="sm"
            titleComponent="Delete Assessment from Jobvite"
            actionComponent={(
                    <>
                        <Button
                            color="primary"
                            className={classes.actionButton}
                            onClick={onClose}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={loading}
                            className={classes.deleteButton}
                            onClick={deleteFromJobVite}
                        >
                            {
                                loading ? (
                                    <CircularProgress
                                        size={24}
                                        thickness={3}
                                        classes={{ root: classes.loader }}
                                    />
                                ) : <span>Delete Assessment</span>
                            }
                        </Button>
                    </>
            )}
            open={open}
            onClose={onClose}
            handleClose={onClose}
        >
                Are you sure you want to delete this assessment from Jobvite? <br /> This action is not recoverable and all data relevant to this assessment will be lost in Jobvite.
        </Dialog>
    );
};

export default withStyles(styles)(DeleteAssessmentFromJobViteDialog);
